import styled from "styled-components"

// const BPSAccordionStyled = styled.div`

// .ant-collapse-header {
//     font-size: 1.25rem;
//     font-weight: bold;
//     color: #4d4d4d !important;
//     background-color: transparent;

// }

// .ant-collapse>.ant-collapse-item-active >.ant-collapse-header .ant-collapse-header-text {
//     color: #0478c2;
// }

// .ant-collapse>.ant-collapse-item {
//     margin: 1rem 0rem;
//     background-color: transparent;
//     border: none;
// }

// .ant-collapse>.ant-collapse-item-active {
//     border-radius: 0px;

//     svg {
//         fill: #0478c2;
//     }
// }

// .ant-collapse {
//     border: none;
//     background-color: transparent;
// }

// .ant-collapse-content {
//     border: none !important;
//     margin-left: 1.5rem;
//     background-color: transparent;
// }

// `

const BPSAccordionStyled = styled.div`

    .accordion-item {
        border: none;
        color: #4d4d4d;
        background: transparent;

    }

    .accordion-body {
        img {
            margin: auto;
        }
    }

    .accordion-header {
        background-color: transparent;
        font-weight: bold !important;
        border: none !important;
    }
    

    .accordion-button:not(.collapsed) {
        background-color: transparent;
        color: #0478c2;
        box-shadow: none;
    }

    .accordion-button { 
        background-color: transparent;
        font-weight: bold;
        font-size: 1.25rem;
        color: #4d4d4d;
        border-top: 1px solid #cccccc;
        border-radius: 0px;

        &:focus {
            box-shadow: none;
        }
    }

`

export { BPSAccordionStyled }
